export default __webpack_public_path__ + "static/media/vbb-picture-logo.84b518fc.png";